<div>
    <div class="row">
        @if (featureImageAsset) {
            <div class="col-md mb-6 mb-md-0">
                <img class="img-fluid plan-image" [src]="featureImageAsset.urlPath" [attr.aria-label]="featureImageAsset.imageAltText">
            </div>    
        }
        <div class="col-md gx-md-5 mx-5 mx-md-0">
            <p class="gb-body2 heavy mb-1">{{featureCopy.name}}</p>
            @let brand = brand$ | async;
            <p class="gb-body2 m-0">{{addBrandToDescription(featureCopy.description, brand)}}</p>
        </div>
    </div>
</div>